module.exports = __webpack_public_path__ + "static/3-999b5c30c4b06833cfd2921bf0591624.jpg";